<div class="subscriptions-list flex-container direction-row flex-wrap flex-center">
    <div class="plan-box user-plan" *ngFor="let item of model.userPlan; index as i">
        <div class="plan-box-title">
            <h1 translate>
                <span>{{item.name}}</span>
                <span *ngIf="item.durationPrice>0">
                    <span> /</span>
                    {{item.durationPrice}}$
                </span>
            </h1>
        </div>
        <div class="plan-box-divider"></div>
        <div class="plan-box-basic">
            <div class="plan-features">
                <div class="plan-features-text">
                    <h3 translate>Land.Features</h3>
                </div>
                <div class="bulet"></div>
            </div>
            <div class="plan-features-description">
                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        SignUp.AnalyticTickers
                    </div>
                    <div class="feature-item-count" translate>
                        Enum.All
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        SignUp.AnalyticTools
                    </div>
                    <div class="feature-item-count" translate>
                        Enum.All
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        Land.FilterTitleVolume
                    </div>
                    <div class="feature-item-count" translate>
                        Land.Yes
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        Land.FilterTitleTarget
                    </div>
                    <div class="feature-item-count" translate>
                        Land.Yes
                    </div>
                </div>
                <div *ngIf="item.durationPrice>0" class="feature-item">
                    <div class="feature-item-name" translate>
                        Land.Support
                    </div>
                    <div class="feature-item-count">
                        <span translate>Land.Yes</span>
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        SignUp.AlertingTickers
                    </div>
                    <div class="feature-item-count" translate>
                        {{item.tickers}}
                    </div>
                </div>

                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        SignUp.Setups
                    </div>
                    <div class="feature-item-count">
                        {{item.setups}}
                    </div>
                </div>


                <div class="feature-item">
                    <div class="feature-item-name">
                        {{'Land.Duration' | translate}} {{item.duration}} <span translate>Land.DurationPeriod.{{durationTypes[item.durationType]}}</span>
                    </div>
                    <div *ngIf="item.durationPrice>0" class="feature-item-count">
                        {{item.durationPrice}}$
                    </div>
                </div>
                <!--<div class="feature-item">
                    <div class="feature-item-name" translate>
                        Land.Renewable
                    </div>
                    <div class="feature-item-count">
                        <span *ngIf="repetitionTypes[item.repetition] != 'Once'" translate>Land.Yes</span>
                        <span *ngIf="repetitionTypes[item.repetition] == 'Once'" translate>Land.No</span>
                    </div>
                </div>-->

                <div class="feature-item" *ngIf="repetitionTypes[item.repetition] != 'Once'">
                    <div class="feature-item-name" translate>
                        {{'Land.ExtraTickers' | translate: {value: item.tickersPerBatch} }}
                    </div>
                    <div class="feature-item-count">
                        {{item.tickersBatch}}$
                    </div>
                </div>
                <div class="feature-item" *ngIf="repetitionTypes[item.repetition] != 'Once'">
                    <div class="feature-item-name" translate>
                        {{'Land.ExtraSetups' | translate: {value: item.setupsPerBatch} }}
                    </div>
                    <div class="feature-item-count">
                        {{item.setupsBatch}}$
                    </div>
                </div>

            </div>
        </div>
        <div class="subscribe">
            <div class="bright-button flex-container align-center" *ngIf="i+1 == model.userPlan.length">
                <a class="mark-button button-cut" (click)="showMore = true" translate>Land.ShowMore</a>
            </div>
            <a class="subscribe-button" [routerLink]="['/auth/signup']" [queryParams]="{id:item.id}">
                <img src="../../../../assets/home/subscribe.svg" />
            </a>
        </div>
    </div>
</div>
<div class="subscriptions-list flex-container direction-row flex-wrap flex-center">
    <div class="plan-box" *ngFor="let item of model.plans"
         [hidden]="model.userPlan.length != 0 && (model.userPlan.length == 0 || !showMore)">
        <div class="plan-box-title">
            <h1 translate>
                <span>{{item.name}}</span>
                
                <span *ngIf="item.durationPrice>0">
                    <span> /</span>
                    {{item.durationPrice}}$
                </span>
            </h1>
        </div>
        <div class="plan-box-divider"></div>
        <div class="plan-box-basic">
            <div class="plan-features">
                <div class="plan-features-text">
                    <h3 translate>Land.Features</h3>
                </div>
                <div class="bulet"></div>
            </div>
            <div class="plan-features-description">
                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        SignUp.AnalyticTickers
                    </div>
                    <div class="feature-item-count" translate>
                        Enum.All
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        SignUp.AnalyticTools
                    </div>
                    <div class="feature-item-count" translate>
                        Enum.All
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        Land.FilterTitleVolume
                    </div>
                    <div class="feature-item-count" translate>
                        Land.Yes
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        Land.FilterTitleTarget
                    </div>
                    <div class="feature-item-count" translate>
                        Land.Yes
                    </div>
                </div>
                <div *ngIf="item.durationPrice>0" class="feature-item">
                    <div class="feature-item-name" translate>
                        Land.Support
                    </div>
                    <div class="feature-item-count">
                        <span translate>Land.Yes</span>
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        SignUp.AlertingTickers
                    </div>
                    <div class="feature-item-count" translate>
                        {{item.tickers}}
                    </div>
                </div>

                <div class="feature-item">
                    <div class="feature-item-name" translate>
                        SignUp.Setups
                    </div>
                    <div class="feature-item-count">
                        {{item.setups}}
                    </div>
                </div>

                <!--<div class="feature-item">
                    <div class="feature-item-name" translate>
                        Land.Renewable
                    </div>
                    <div class="feature-item-count">
                        <span *ngIf="repetitionTypes[item.repetition] != 'Once'" translate>Land.Yes</span>
                        <span *ngIf="repetitionTypes[item.repetition] == 'Once'" translate>Land.No</span>
                    </div>
                </div>-->
                <div class="feature-item">
                    <div class="feature-item-name">
                        {{'Land.Duration' | translate}} {{item.duration}} <span translate>Land.DurationPeriod.{{durationTypes[item.durationType]}}</span>
                    </div>
                    <div *ngIf="item.durationPrice>0" class="feature-item-count">
                        {{item.durationPrice}}$
                    </div>
                </div>

                <div class="feature-item" *ngIf="repetitionTypes[item.repetition] != 'Once'">
                    <div class="feature-item-name" translate>
                        {{'Land.ExtraTickers' | translate: {value: item.tickersPerBatch} }}
                    </div>
                    <div class="feature-item-count">
                        {{item.tickersBatch}}$
                    </div>
                </div>
                <div class="feature-item" *ngIf="repetitionTypes[item.repetition] != 'Once'">
                    <div class="feature-item-name" translate>
                        {{'Land.ExtraSetups' | translate: {value: item.setupsPerBatch} }}
                    </div>
                    <div class="feature-item-count">
                        {{item.setupsBatch}}$
                    </div>
                </div>
            </div>
        </div>
        <div class="subscribe">
            <a class="subscribe-button" [routerLink]="['/auth/signup']" [queryParams]="{id:item.id}">
                <img src="../../../../assets/home/subscribe.svg" />
            </a>
        </div>
    </div>
</div>